// extracted by mini-css-extract-plugin
export default {"main_layout":"Login_main_layout__TxpM8","login_form":"Login_login_form__iVG2U"};